module.exports = __webpack_public_path__ + "static/media/template-loan.506aeff11abb17125b3a7354e144b93c.png";